import type { Middleware } from 'redux';

/**
 * A custom thunk middleware that reads `store.dispatch` at invocation time
 * instead of capturing it in a closure at composition time.
 *
 * The standard `redux-thunk` destructures `{ dispatch } = store` once during
 * `applyMiddleware`, then passes that stale reference to every thunk. Reading
 * `store.dispatch` at invocation time instead keeps thunks robust to any
 * later reassignment of `store.dispatch`, so actions dispatched from within a
 * thunk always flow through the current dispatch (and therefore the full
 * middleware chain).
 */
export const instrumentedThunkMiddleware: Middleware = (store) => (next) => (action) => {
    if (typeof action === 'function') {
        return action(store.dispatch, store.getState);
    }
    return next(action);
};
